import React from 'react';
import { useLocation, Link } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  
  const getHeaderTitle = () => {
    switch (location.pathname) {
      case '/medicare-advantage':
        return 'Medicare Advantage Plans';
      case '/medicare-supplement':
        return 'Medicare Supplement Plans';
      default:
        return 'Mutual Advisors';
    }
  };

  return (
    <div className="header py-2 py-lg-4 sticky-top">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-lg-3 px-md-5 col-md-4 d-none d-md-block">
            <img src="img/small2.png" alt="" width="30px" className="img-fluid" />
            <span style={{
              fontSize: '2em',
              color: '#0d3a34',
              fontFamily: 'Archivo, serif',
              fontWeight: 500
            }}>
              {getHeaderTitle()}
            </span>
          </div>
          <div className="col-lg-6 px-md-5 col-md-6 text-center">
            {/* Navigation Menu Removed */}
          </div>
          <div className="col-lg-3 px-md-5 col-md-2 text-center text-md-end">
            <div className="header__right mb-1">
              <a href="tel:+13059288867" className="header__right-link mb-1 d-inline-block dni-phone-btn-link">
                <span className="header__text-2 pe-3 heading--7">
                  <i className="fa-solid fa-phone-volume fa-fade"></i>
                </span>
                <span className="header__text-3 pe-2 heading--7 dni-phone-content">[Phone Number]</span>
                <span>(TTY 711) 24/7</span>
              </a>
              <div className="d-flex align-items-center flex-row justify-content-center justify-content-md-end">
                <span className="pe-2 header__text-4">
                  <i className="fa-solid fa-circle"></i>
                </span>
                <span className="header__text-5">Available Mon-Fri: 9am-6pm EST</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
